const PREFIX = 'FORUM'

export const FORUM_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`
export const FORUM_CATEGORIES_GET = `${PREFIX}_CATEGORIES_GET`
export const FORUMS_GET = `${PREFIX}S_GET`
export const FORUM_GET = `${PREFIX}_GET`

export const FORUM_COMMENTS_GET = `${PREFIX}_COMMENTS_GET`
export const FORUM_COMMENTS_GET_ERROR = `${PREFIX}_COMMENTS_GET_ERROR`

export const FORUM_COMMENT_ADD_STATUS = `${PREFIX}_COMMENT_ADD_STATUS`
export const FORUM_COMMENT_ADD = `${PREFIX}_COMMENT_ADD`

export const FORUM_POST_ADD_STATUS = `${PREFIX}_POST_ADD_STATUS`
export const FORUM_POST_ADD = `${PREFIX}_POST_ADD`

export const FORUM_CHOSE_CATEGORY = `${PREFIX}_CHOSE_CATEGORY`
export const FORUM_CHOSE_CATEGORY_DELETE = `${PREFIX}_CHOSE_CATEGORY_DELETE`

export const FORUM_COMMENT_LIKE = `${PREFIX}_COMMENT_LIKE`
export const FORUM_COMMENT_DELETE = `${PREFIX}_COMMENT_DELETE`
export const FORUM_COMMENT_REPLY = `${PREFIX}_COMMENT_REPLY`

export const FORUM_COMMENT_ADD_ERROR = `${PREFIX}_COMMENT_ADD_ERROR`
export const FORUM_CATEGORIES_ERROR = `${PREFIX}_CATEGORIES_ERROR`
export const FORUM_POST_ADD_ERROR = `${PREFIX}_POST_ADD_ERROR`

export const FORUM_EDIT = `${PREFIX}_EDIT`
export const FORUM_EDIT_LOADING_STATUS = `${PREFIX}_EDIT_LOADING_STATUS`
export const FORUM_ACTIVE_COMMENT = `${PREFIX}_ACTIVE_COMMENT`

export const FORUM_MODAL_CATEGORY = `${PREFIX}_MODAL_CATEGORY`
export const FORUM_MODAL_CATEGORY_LOADING = `${PREFIX}_MODAL_CATEGORY_LOADING`

